import React from 'react';
import { IonModal } from '@ionic/react';
import CtaItem from './CtaItem';
import '../cart/cta.css';
import { useTranslation } from 'react-i18next';

export default function CtaNoOrders(props) {
    const { element } = props;

    const { t } = useTranslation();

    const [showModal, setShowModal] = React.useState(false);

    const onOpenHandler = () => setShowModal(true);
    const onCloseHandler = () => setShowModal(false);

    return (
        <div className="cta-no-orders py-2 border-t border-t-grey-400 text-center bg-grey-400 rounded-b-lg">
            <button type="button" className="text-black w-full" onClick={onOpenHandler}>{t("ctanoorders.button_1")}</button>

            <IonModal isOpen={showModal} onDidDismiss={onCloseHandler} mode="md" css-class="custom-cta">
                <CtaItem element={element} closerHandler={onCloseHandler}></CtaItem>
            </IonModal>
        </div>
    );
}
